import React, { useCallback, useState } from "react";
import { AdvancedMarker, Pin, InfoWindow } from "@vis.gl/react-google-maps";
import {
    INFO_WINDOW_NONE,
    INFO_WINDOW_BOOKING,
    INFO_WINDOW_WAITLIST
} from "../../utils/Constants";
import { useAtom } from "jotai";
import {
    openedInfoWindowTypeAtom,
    canShowBookingInfoWindowAtom,
    canShowWaitlistInfoWindowAtom
} from "./analysisAtoms";
const MapMarker = ({
    data,
    dataKey,
    getPosition,
    getPinColor,
    infoWindowContent,
    infoWindowHeaderText
}) => {
    const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
    const [, setOpenedInfoWindowType] = useAtom(openedInfoWindowTypeAtom);
    const [canShowBookingInfoWindow] = useAtom(canShowBookingInfoWindowAtom);
    const [canShowWaitlistInfoWindow] = useAtom(canShowWaitlistInfoWindowAtom);

    const handleMarkerClick = useCallback((index) => {
        setSelectedMarkerIndex(index);
        setOpenedInfoWindowType(
            dataKey === "id" ? INFO_WINDOW_BOOKING : INFO_WINDOW_WAITLIST
        );
    }, []);

    const handleInfoWindowClose = useCallback(() => {
        setSelectedMarkerIndex(null);
        setOpenedInfoWindowType(INFO_WINDOW_NONE);
    }, []);

    return (
        <>
            {data?.map((item, index) => (
                <AdvancedMarker
                    key={item[dataKey]}
                    position={getPosition(item)}
                    onClick={() => handleMarkerClick(index)}
                >
                    <>
                        <Pin
                            background={getPinColor(item)}
                            borderColor={getPinColor(item)}
                            glyphColor="white"
                        />
                        {selectedMarkerIndex === index &&
                            ((canShowBookingInfoWindow && dataKey === "id") ||
                                (canShowWaitlistInfoWindow &&
                                    dataKey === "prospectId")) && (
                                <InfoWindow
                                    position={getPosition(item)}
                                    onCloseClick={handleInfoWindowClose} // Still keep close on click for accessibility
                                    headerContent={
                                        <h4>{infoWindowHeaderText}</h4>
                                    }
                                    pixelOffset={[0, -30]} // otherwise mouseleave event does not trigger
                                >
                                    {infoWindowContent(item)}
                                </InfoWindow>
                            )}
                    </>
                </AdvancedMarker>
            ))}
        </>
    );
};

export default MapMarker;
